import React from "react";
import RIWA from "../../assets/images/Riwa.jpeg";
import GLine from "../../assets/images/line.png";
import { Bounce, Fade, Flip } from "react-reveal";
const Founders = () => {
  return (
    <div className="flex flex-col justify-center items-center mt-6 sm:mt-8 md:mt-10 lg:mt-12 xl:mt-16 2xl:mt-24">
      <p className="font-['FuturaExtraBold'] text-2xl sm:text-3xl md:text-4xl lg:text-5xl xl:text-6xl 2xl:text-7xl text-[#00693A]">
        <Fade top> FOUNDER</Fade>
      </p>
      <div className="mt-3 space-y-6 sm:space-y-10 md:space-y-12 lg:space-y-16 xl:space-y-24 mx-[1%] sm:mx-[5%] xl:mx-[7%] 2xl:mx-[10%] mt-4 sm:mt-6 md:mt-8 lg:mt-12 xl:mt-16 2xl:mt-24">
        <div className="flex flex-col md:flex-row justify-center items-center md:items-start">
          <div className="h-[250px] w-[200px] md:h-[300px] md:min-w-[250px] lg:h-[350px] lg:min-w-[300px] xl:h-[400px] xl:min-w-[350px] bg-[#00693A] rounded-2xl relative shadow-2xl">
            <div
              className="rounded-2xl absolute shadow-2xl h-[250px] w-[200px] md:h-[300px] md:min-w-[250px] lg:h-[350px] lg:min-w-[300px] xl:h-[400px] xl:min-w-[350px] z-40"
              style={{
                marginLeft: "-10px",
                marginTop: "10px",
                backgroundImage: `url(${RIWA})`,
                backgroundRepeat: "no-repeat",
                backgroundSize: "cover",
                backgroundPosition: "top",
              }}
            />
          </div>
          <div className="hidden md:block flex md:justify-start md:items-start mt-4">
            <Bounce left>
              <img
                src={GLine}
                alt={""}
                className="hidden md:block md:min-w-[100px] lg:min-w-[150px] xl:min-w-[200px] 2xl:min-w-[300px]"
              />
            </Bounce>
          </div>

          <div className="mx-[20%] md:mx-1 mt-12 md:mt-1 flex flex-col justify-center items-center md:justify-start md:items-end md:px-12 lg:px-16 xl:px-20 2xl:px-32">
            <p className="text-sm sm:text-md md:text-lg lg:text-xl xl:text-2xl 2xl:text-3xl px-3 py-1  2xl:px-5 2xl:py-2 font-['FuturaLight']">
              <p className="text-xl sm:text-2xl md:text-3xl lg:text-4xl xl:text-6xl 2xl:text-7xl text-[#00693A] md:pb-3  xl:pb-4 2xl:pb-6 -ml-1 font-['FuturaMed']">
                <Flip cascade right>
                  Riwa Ghawi
                </Flip>
              </p>
              Social and Climate Justice advocate, with a focus on gender
              equality, freedom of speech and climate awareness. Riwa works on
              capacity development among youth, and is a trainer on advocacy and
              leadership.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Founders;
